import { AnalyticsEvent, GTMEventData } from "@hermes/fragments/analytics";

interface TakeAppointmentEvent {
    eventaction: "Take appointment";
    eventlabel: string;
}

interface SearchStoreEventData {
    eventaction: "Search a store";
    eventlabel: string;
}

interface GeolocationEventData {
    eventaction: "Search - Use my location";
    eventlabel: string;
}

interface GetDirectionEventData {
    eventaction: "Get_Directions";
    // Name of the store
    eventlabel: string;
    // Store position on the list
    eventvalue: string;
}

interface MoreInfoEventData {
    eventaction: "More information";
    // Name of the store
    eventlabel: string;
    // Store position on the list
    eventvalue: string;
}

interface MarkerEventData {
    eventaction: "Map view click marker";
    // Name of the store
    eventlabel: string;
}

interface PhoneLinkEventData {
    eventaction: "Phone Call";
    // Name of the store
    eventlabel: string;
}

export type ShopLocatorEventData =
    | SearchStoreEventData
    | TakeAppointmentEvent
    | GeolocationEventData
    | GetDirectionEventData
    | MoreInfoEventData
    | MarkerEventData
    | PhoneLinkEventData;

/**
 * Abstract class for ShopLocator events
 */
export class ShopLocatorEvent implements AnalyticsEvent<GTMEventData> {
    /**
     * Event name expected for every uaevent event
     */
    public name: string = "uaevent";

    /**
     * Event's data from component to format correctly ShopLocator event
     */
    public eventData: ShopLocatorEventData;

    constructor(data: ShopLocatorEventData) {
        this.eventData = data;
    }

    /**
     * Overloaded by each subclass with their own formatter
     * Return event formatted to send to GTM
     */
    public formatForGTM(): GTMEventData {
        const eventvalue: string | undefined = (
            this.eventData as GetDirectionEventData | MoreInfoEventData
        ).eventvalue;

        return {
            event: this.name,
            eventcategory: "Store Locator",
            eventaction: this.eventData.eventaction,
            eventlabel: this.eventData.eventlabel,
            ...(eventvalue && { eventvalue }),
        };
    }
}
